import { motion } from "framer-motion";

export default function LegalLayout({ title, lastUpdated, intro, children, testid }) {
  return (
    <div className="max-w-3xl mx-auto px-5 lg:px-8 py-12 lg:py-20" data-testid={testid}>
      <motion.div
        initial={{ opacity: 0, y: 14 }} animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
      >
        <span className="text-xs font-semibold tracking-widest uppercase text-brand-teal">Legal</span>
        <h1 className="mt-3 text-4xl sm:text-5xl font-bold tracking-tight text-brand-ink">{title}</h1>
        <p className="text-xs text-brand-muted mt-3">Last updated · {lastUpdated}</p>
        {intro && (
          <div className="mt-6 bg-brand-teal/5 border border-brand-teal/20 rounded-2xl p-4 text-sm text-brand-ink" data-testid="draft-disclaimer">
            {intro}
          </div>
        )}
        <div className="mt-10 prose-style space-y-7 text-[15px] leading-relaxed text-brand-ink">
          {children}
        </div>
      </motion.div>
    </div>
  );
}

export function Section({ heading, children, id }) {
  return (
    <section id={id} className="space-y-3">
      <h2 className="text-xl font-bold tracking-tight text-brand-ink">{heading}</h2>
      <div className="space-y-3 text-brand-ink/90">{children}</div>
    </section>
  );
}
